require("@aspen/Aspen/MarkupScripts/MobileNavPlugin.js")

export default function initMobileNav() {

    const interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.mobileNav === undefined) {
            return true;
        }
        const $ = window.jQuery;
            window.jQuery('body').mobileNav({
            menuActiveClass: 'as-nav-active',
            menuOpener: '.as-nav-opener'
        });

        window.jQuery(".as-nav-opener").click(function (e: any) {
            const currentValue = $(e.currentTarget).attr('aria-expanded');
            if (currentValue === 'false') {
                $(e.currentTarget).attr('aria-expanded', 'true');
            } else {
                $(e.currentTarget).attr('aria-expanded', 'false');
            }
        });
        clearInterval(interval);
    }, 1000);
}